
export const FETCH_REPORTS_REQUEST = "FETCH_REPORTS_REQUEST"
export const FETCH_REPORTS_SUCCESS = "FETCH_REPORTS_SUCCESS"
export const FETCH_REPORTS_FAILED = "FETCH_REPORTS_FAILED"

export const UPDATE_REPORTS = "UPDATE_REPORTS"


export const SELECT_REPORT = "SELECT_REPORT"

